import React, { createContext, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import Users from 'cloudtern/components/Users';
import Searches from 'cloudtern/components/Searches';
import Likes from 'cloudtern/components/Likes';
import Dislikes from 'cloudtern/components/Dislikes';
import Dashboard from 'cloudtern/components/Dashboard';
import Unanswered_questions from 'cloudtern/components/Unanswered_questions';

import Cube from 'examples/Icons/Cube';
import { ThumbsUp, ThumbsDown, Users as UsersIcon, AlertCircle, Search } from 'lucide-react';

export const RoutesContext = createContext();

const RoutesProvider = ({ children }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [dateRange, setDateRange] = useState({
    start_date: params.get("start_date"),
    end_date: params.get("end_date"),
  });

  const queryString = `?start_date=${dateRange.start_date}&end_date=${dateRange.end_date}`;

  const routes = useMemo(() => [
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      route: "/dashboard",
      link: `/dashboard${queryString}`, 
      icon: <Cube size="12px" />,
      noCollapse: true,
      component: <Dashboard key="dashboard" />,
    },
    {
      type: "collapse",
      name: "Visitors",
      key: "visitors",
      route: "/visitors",
      link: `/visitors${queryString}`,
      icon: <UsersIcon size="14px" />,
      noCollapse: true,
      component: <Users key="visitors" />,
    },
    {
      type: "collapse",
      name: "Queries",
      key: "queries",
      route: "/queries",
      link: `/queries${queryString}`,
      icon: <Search size="14px" />,
      noCollapse: true,
      component: <Searches key="queries" />,
    },
    {
      type: "collapse",
      name: "Likes",
      key: "likes",
      route: "/likes",
      link: `/likes${queryString}`,
      icon: <ThumbsUp size="14px" />,
      noCollapse: true,
      component: <Likes key="likes" />,
    },
    {
      type: "collapse",
      name: "Dislikes",
      key: "dislikes",
      route: "/dislikes",
      link: `/dislikes${queryString}`,
      icon: <ThumbsDown size="14px" />,
      noCollapse: true,
      component: <Dislikes key="dislikes" />,
    },
    {
      type: "collapse",
      name: "Unanswered",
      key: "unanswered",
      route: "/unanswered",
      link: `/unanswered`, 
      icon: <AlertCircle size="14px" />,
      noCollapse: true,
      component: <Unanswered_questions key="unanswered" />,
    },
  ], [queryString]);

  return (
    <RoutesContext.Provider value={{ routes, dateRange, setDateRange }}>
      {children}
    </RoutesContext.Provider>
  );
};

export default RoutesProvider;
